import LoadingPartial from "common/components/partials/loading";

export default function Loading() {
  return (
    <div className="container mx-auto my-20 text-center">
      <LoadingPartial />
    </div>
  );
}
